import { HttpResult } from 'widgets-for-react'
import { cmsPageUrl } from '../../utils/cmsPageUrl'
import { ResearchPageData } from '../cmsPage/sharepointPageApi/types/pageData'
import { ResearchPerPatientsNeeded } from './researchOverviewState'

type ResearchData = {
  Item1: ResearchPageData[]
  Item2: ResearchPageData[]
}

export const GetResearchByPatients = async (): Promise<HttpResult<ResearchPerPatientsNeeded>> => {
  const res = await fetch('/api/v1/pages/research/patient')

  if (!res.ok)
    return {
      kind: 'failed',
      status: res.status,
    }

  const data: ResearchData = await res.json()

  return {
    kind: 'result',
    status: 200,
    value: {
      patientsNeeded: data.Item1.map((item) => ({
        title: item.HeaderTitle,
        intro: item.TeaserDescription,
        topic: item.Onderwerp,
        departments: item.Research.Departments.map((deparment) => deparment.Title),
        url: cmsPageUrl(item),
      })),

      noPatientsNeeded: data.Item2.map((item) => ({
        title: item.HeaderTitle,
        intro: item.TeaserDescription,
        topic: item.Onderwerp,
        departments: item.Research.Departments.map((deparment) => deparment.Title),
        url: cmsPageUrl(item),
      })),
    },
  }
}
